// Brand assets (uploaded) + generated cinematic imagery
export const ASSETS = {
  monogram: "https://customer-assets.emergentagent.com/job_5c247729-635d-41a8-9624-4432fcb03f7a/artifacts/ru2wwkyr_E8C8A237-BBD2-4283-AA7E-D1C2B6C8B496.png",
  sealDark: "/seal-dark.png",
  sealLight: "/seal-light.png",
  sealGold: "/seal-gold.png",
  wordmark: "/wordmark-dark.png",
  goldStone: "https://customer-assets.emergentagent.com/job_5c247729-635d-41a8-9624-4432fcb03f7a/artifacts/xce0v1e9_E8F099A8-8C3B-4769-BF56-FD30BFEEC1D1.png",
  hero: "https://static.prod-images.emergentagent.com/jobs/5c247729-635d-41a8-9624-4432fcb03f7a/images/6d7df9747df7ece2eb0972f717800d47cfd91aa162ac5b4dcb7e02509d50fe9e.png",
  territory: "https://static.prod-images.emergentagent.com/jobs/5c247729-635d-41a8-9624-4432fcb03f7a/images/edd544985d1514f13bf450a27036a1f4bc08cb7e1b6c183ff9737460cfdc1b05.png",
  hands: "https://static.prod-images.emergentagent.com/jobs/5c247729-635d-41a8-9624-4432fcb03f7a/images/c809203cb3646696208b7accfeef71a1cc2a1ca1d345f7967ac28ad9367cbc13.png",
  assay: "https://static.prod-images.emergentagent.com/jobs/5c247729-635d-41a8-9624-4432fcb03f7a/images/0d02cd9870237ceccf128c5731f624d5724200f28ee833ae3d80a0fef19117da.png",
  earth: "https://static.prod-images.emergentagent.com/jobs/5c247729-635d-41a8-9624-4432fcb03f7a/images/9ec77c86d865a8b2f11d6ffbf8173df28bb0b0c8e27780848ee41363b0557204.png",
  trade: "https://static.prod-images.emergentagent.com/jobs/5c247729-635d-41a8-9624-4432fcb03f7a/images/7d3f0bdb5287e377864691c6d70a1f8f4ff92aa7f486cc5abff92e8ff12744d9.png",
};

export const COLORS = [
  { name: "Mineral Ivory", hex: "#F5F0E6", en: "Clarity, documentation, purity and light.", es: "Claridad, documentación, pureza y luz.", dark: false },
  { name: "Warm Gold", hex: "#B9974F", en: "Value, excellence and precious matter.", es: "Valor, excelencia y materia preciosa.", dark: true },
  { name: "Mineral Black", hex: "#171713", en: "Depth, origin, solidity and permanence.", es: "Profundidad, origen, solidez y permanencia.", dark: true },
  { name: "Earth Brown", hex: "#6E4328", en: "Territory, warmth and raw material.", es: "Territorio, calidez y materia prima.", dark: true },
  { name: "Deep Burgundy", hex: "#6B1111", en: "Distinction, heritage and the atmosphere of a private house.", es: "Distinción, herencia y la atmósfera de una casa privada.", dark: true },
];

export const translations = {
  en: {
    nav: { house: "The House", origin: "Origin", operations: "Operations", standards: "Standards", responsibility: "Responsibility", trade: "Global Trade", inquiries: "Inquiries", brand: "Brand System" },
    cta: { inquiries: "Commercial Inquiries", back: "Back to TOTUMO" },
    hero: { subtitle: "House of Gold", tagline: "Origin. Craft. Value.", line: "From earth to excellence.", scroll: "Scroll" },
    strip: ["Responsible Sourcing", "Provenance & Traceability", "Assay & Compliance", "Global Export"],
    house: {
      eyebrow: "The House",
      title: "A house for rare matter. A vessel for origin value.",
      body: [
        "TOTUMO is an origin gold house dedicated to the responsible sourcing, commercialization and export of gold. Built around provenance, refinement and enduring value, the house connects rare matter from its origin to global commercial standards.",
        "Beyond extraction or trade, TOTUMO represents custody, provenance and transformation, the journey of rare matter from its natural origin into a refined, accountable and enduring form of value."
      ],
      pillars: [
        { k: "Origin", v: "We protect the value of where gold begins." },
        { k: "Craft", v: "We treat process, handling and presentation with precision." },
        { k: "Value", v: "We work with rare matter and enduring commercial worth." },
        { k: "Integrity", v: "We operate with accountability, documentation and responsibility." },
      ],
    },
    origin: {
      eyebrow: "Origin Gold",
      title: "Gold begins with place.",
      body: [
        "TOTUMO works from origin, where matter, territory and process define value. Each operation is guided by traceability, documentation and a commitment to accountable extraction.",
        "We hold room for the names of mines, the regions they belong to and the certifications that accompany them, so that every gram can be traced to where it began.",
      ],
      meta: [
        { k: "Region", v: "Bogotá · Colombia" },
        { k: "Provenance", v: "Documented at source" },
        { k: "Territory", v: "Mine names & regions on record" },
      ],
    },
    operations: {
      eyebrow: "Operations",
      title: "The chain, from earth to export.",
      intro: "Every gram passes through a single, accountable chain, elegant in language, exact in practice.",
      steps: [
        { n: "01", k: "Extraction", v: "Gold recovered at origin under accountable conditions." },
        { n: "02", k: "Selection", v: "Careful grading and selection of rare matter." },
        { n: "03", k: "Analysis", v: "Assay and verification of purity and composition." },
        { n: "04", k: "Documentation", v: "Provenance, custody and compliance records." },
        { n: "05", k: "Commercialization", v: "Structured, transparent commercial process." },
        { n: "06", k: "Export", v: "Logistics and delivery to global markets." },
      ],
    },
    standards: {
      eyebrow: "Gold Standards",
      title: "Every gram carries a standard.",
      intro: "From selection and analysis to documentation and export, TOTUMO works with precision, clarity and control across the gold value chain.",
      items: [
        { k: "Purity", v: "Verified fineness and composition." },
        { k: "Assay", v: "Independent analysis of every lot." },
        { k: "Weighing", v: "Calibrated, witnessed measurement." },
        { k: "Custody", v: "Chain-of-custody records at each step." },
        { k: "Compliance", v: "Legal and regulatory documentation." },
        { k: "Logistics", v: "Secured, documented transport and export." },
      ],
    },
    responsibility: {
      eyebrow: "Responsibility",
      title: "True value requires responsibility.",
      body: [
        "TOTUMO is committed to operating with legal traceability, environmental awareness and long-term respect for the communities and territories connected to its origin gold.",
        "We build standards designed to last, protecting the land, the people and the provenance behind every gram.",
      ],
      points: [
        { k: "Legal traceability", v: "Documented, compliant sourcing." },
        { k: "Environmental care", v: "Awareness and stewardship of the land." },
        { k: "Community standards", v: "Respect for the people of the territory." },
        { k: "Accountability", v: "Long-term, transparent responsibility." },
      ],
    },
    trade: {
      eyebrow: "Global Trade",
      title: "Origin gold, delivered to the world.",
      body: [
        "TOTUMO connects rare matter from its origin to global commercial standards, with the capability to commercialize and export to institutional partners.",
        "We operate openly and formally, building enduring relationships with refineries, institutions and commercial partners across markets.",
      ],
      stats: [
        { k: "Export", v: "Institutional & commercial" },
        { k: "Partners", v: "Refineries · Institutions" },
        { k: "Standard", v: "Documented & compliant" },
      ],
    },
    inquiries: {
      eyebrow: "Inquiries",
      title: "Commercial & institutional inquiries.",
      body: "For commercial and institutional matters, reach the house directly. Each inquiry is handled with discretion and care.",
      office: "Principal Office",
      officeValue: "Calle 106 # 6, Bogotá, Colombia",
      addressLabel: "Address",
      addressValue: "To be confirmed",
      phoneLabel: "Telephone",
      phoneValue: "To be confirmed",
      form: {
        name: "Full name", email: "Email", company: "Company / Institution",
        subject: "Subject", message: "Message", submit: "Send Inquiry", sending: "Sending…",
        success: "Thank you. Your inquiry has been received.", error: "Something went wrong. Please try again.",
      },
    },
    footer: {
      tagline: "A house for rare matter. A vessel for origin value.",
      brandSystem: "Brand System",
      brandSystemNote: "Explore the house codes",
      rights: "All rights reserved.",
      nav: "Navigate",
    },
  },

  es: {
    nav: { house: "La Casa", origin: "Origen", operations: "Operaciones", standards: "Estándares", responsibility: "Responsabilidad", trade: "Comercio Global", inquiries: "Contacto", brand: "Sistema de Marca" },
    cta: { inquiries: "Consultas Comerciales", back: "Volver a TOTUMO" },
    hero: { subtitle: "Casa de Oro", tagline: "Origen. Oficio. Valor.", line: "De la tierra a la excelencia.", scroll: "Desliza" },
    strip: ["Abastecimiento Responsable", "Procedencia y Trazabilidad", "Ensayo y Cumplimiento", "Exportación Global"],
    house: {
      eyebrow: "La Casa",
      title: "Una casa para la materia rara. Un recipiente de valor de origen.",
      body: [
        "TOTUMO es una casa de oro de origen dedicada al abastecimiento responsable, la comercialización y la exportación de oro. Construida en torno a la procedencia, el refinamiento y el valor perdurable, la casa conecta la materia rara desde su origen con los estándares comerciales globales.",
        "Más allá de la extracción o el comercio, TOTUMO representa custodia, procedencia y transformación, el viaje de la materia rara desde su origen natural hacia una forma de valor refinada, responsable y perdurable.",
      ],
      pillars: [
        { k: "Origen", v: "Protegemos el valor de donde comienza el oro." },
        { k: "Oficio", v: "Tratamos el proceso, la manipulación y la presentación con precisión." },
        { k: "Valor", v: "Trabajamos con materia rara y valor comercial perdurable." },
        { k: "Integridad", v: "Operamos con responsabilidad, documentación y rendición de cuentas." },
      ],
    },
    origin: {
      eyebrow: "Oro de Origen",
      title: "El oro comienza con un lugar.",
      body: [
        "TOTUMO trabaja desde el origen, donde la materia, el territorio y el proceso definen el valor. Cada operación se guía por la trazabilidad, la documentación y el compromiso con una extracción responsable.",
        "Reservamos espacio para los nombres de las minas, las regiones a las que pertenecen y las certificaciones que las acompañan, para que cada gramo pueda rastrearse hasta donde comenzó.",
      ],
      meta: [
        { k: "Región", v: "Bogotá · Colombia" },
        { k: "Procedencia", v: "Documentada en origen" },
        { k: "Territorio", v: "Minas y regiones registradas" },
      ],
    },
    operations: {
      eyebrow: "Operaciones",
      title: "La cadena, de la tierra a la exportación.",
      intro: "Cada gramo recorre una única cadena responsable, elegante en el lenguaje, exacta en la práctica.",
      steps: [
        { n: "01", k: "Extracción", v: "Oro recuperado en origen bajo condiciones responsables." },
        { n: "02", k: "Selección", v: "Clasificación y selección cuidadosa de materia rara." },
        { n: "03", k: "Análisis", v: "Ensayo y verificación de pureza y composición." },
        { n: "04", k: "Documentación", v: "Registros de procedencia, custodia y cumplimiento." },
        { n: "05", k: "Comercialización", v: "Proceso comercial estructurado y transparente." },
        { n: "06", k: "Exportación", v: "Logística y entrega a los mercados globales." },
      ],
    },
    standards: {
      eyebrow: "Estándares de Oro",
      title: "Cada gramo lleva un estándar.",
      intro: "Desde la selección y el análisis hasta la documentación y la exportación, TOTUMO trabaja con precisión, claridad y control a lo largo de la cadena de valor del oro.",
      items: [
        { k: "Pureza", v: "Finura y composición verificadas." },
        { k: "Ensayo", v: "Análisis independiente de cada lote." },
        { k: "Pesaje", v: "Medición calibrada y atestiguada." },
        { k: "Custodia", v: "Registros de cadena de custodia en cada paso." },
        { k: "Cumplimiento", v: "Documentación legal y regulatoria." },
        { k: "Logística", v: "Transporte y exportación seguros y documentados." },
      ],
    },
    responsibility: {
      eyebrow: "Responsabilidad",
      title: "El verdadero valor exige responsabilidad.",
      body: [
        "TOTUMO se compromete a operar con trazabilidad legal, conciencia ambiental y respeto a largo plazo por las comunidades y territorios conectados a su oro de origen.",
        "Construimos estándares diseñados para perdurar, protegiendo la tierra, las personas y la procedencia detrás de cada gramo.",
      ],
      points: [
        { k: "Trazabilidad legal", v: "Abastecimiento documentado y conforme." },
        { k: "Cuidado ambiental", v: "Conciencia y cuidado de la tierra." },
        { k: "Estándares comunitarios", v: "Respeto por las personas del territorio." },
        { k: "Rendición de cuentas", v: "Responsabilidad transparente a largo plazo." },
      ],
    },
    trade: {
      eyebrow: "Comercio Global",
      title: "Oro de origen, entregado al mundo.",
      body: [
        "TOTUMO conecta la materia rara desde su origen con los estándares comerciales globales, con la capacidad de comercializar y exportar a socios institucionales.",
        "Operamos de forma abierta y formal, construyendo relaciones duraderas con refinerías, instituciones y socios comerciales en distintos mercados.",
      ],
      stats: [
        { k: "Exportación", v: "Institucional y comercial" },
        { k: "Socios", v: "Refinerías · Instituciones" },
        { k: "Estándar", v: "Documentado y conforme" },
      ],
    },
    inquiries: {
      eyebrow: "Contacto",
      title: "Consultas comerciales e institucionales.",
      body: "Para asuntos comerciales e institucionales, contacte directamente con la casa. Cada consulta se atiende con discreción y cuidado.",
      office: "Oficina Principal",
      officeValue: "Calle 106 # 6, Bogotá, Colombia",
      addressLabel: "Dirección",
      addressValue: "Por confirmar",
      phoneLabel: "Teléfono",
      phoneValue: "Por confirmar",
      form: {
        name: "Nombre completo", email: "Correo electrónico", company: "Empresa / Institución",
        subject: "Asunto", message: "Mensaje", submit: "Enviar Consulta", sending: "Enviando…",
        success: "Gracias. Su consulta ha sido recibida.", error: "Algo salió mal. Inténtelo de nuevo.",
      },
    },
    footer: {
      tagline: "Una casa para la materia rara. Un recipiente de valor de origen.",
      brandSystem: "Sistema de Marca",
      brandSystemNote: "Explore los códigos de la casa",
      rights: "Todos los derechos reservados.",
      nav: "Navegar",
    },
  },
};

export const brandContent = {
  en: {
    eyebrow: "Brand System",
    title: "House Codes",
    subtitle: "Origin. Craft. Value.",
    intro: "The standards, symbols and principles that define TOTUMO as a house of gold.",
    sections: [
      {
        id: "meaning", label: "01 · The Meaning",
        heading: "The Totumo Meaning",
        body: [
          "Totumo begins with the idea of a vessel. In its original form, the totumo is a natural container: an object made to hold, protect and carry what is valuable. For the brand, this meaning is elevated into a contemporary house philosophy.",
          "Totumo is a vessel of origin value: a house created to hold, protect and elevate gold from the earth to the world.",
          "For TOTUMO, gold is not treated as ornament. It is treated as matter, origin, standard and responsibility.",
        ],
      },
      {
        id: "house", label: "02 · House of Gold",
        heading: "House of Gold",
        body: [
          "“House of Gold” defines TOTUMO as a house with its own standards, symbols and principles. It positions the company beyond a traditional mining or trading operation and gives it the character of a maison: structured, refined, trustworthy and built to endure.",
          "The word “House” speaks of continuity, custody, excellence and a system of standards. The word “Gold” speaks of rarity, matter, origin and value.",
        ],
        quote: "A house for rare matter. A vessel for origin value.",
      },
      {
        id: "symbol", label: "03 · The Symbol",
        heading: "The Symbol",
        body: [
          "The TOTUMO symbol is a monogram seal constructed from the rhythm and repetition of the brand’s own letterforms. Built from the geometry of the T and the O, the mark creates a balanced, symmetrical and contained emblem.",
          "The oval frame represents continuity, protection and origin. The internal typographic structure reflects order, precision and refinement. The symbol does not illustrate gold directly, it acts as a house mark: a seal of provenance, value and permanence.",
        ],
        construction: "The mark is built on a vertical axis of symmetry. An oval frame contains the composition, while mirrored and repeated T and O letterforms generate the internal rhythm, measured against a consistent geometric grid.",
        principles: [
          { k: "Oval frame", v: "Continuity, protection and origin." },
          { k: "Internal type", v: "Order, precision and refinement." },
          { k: "Symmetry", v: "Balance, repetition and containment." },
        ],
        usesTitle: "The symbol in use",
        uses: [
          { label: "Certificate seal", note: "Embossed on documents of provenance." },
          { label: "Metal stamp", note: "Struck in gold as a mark of origin." },
          { label: "House sign", note: "Reversed for architecture and signage." },
        ],
      },
      {
        id: "type", label: "04 · Typography",
        heading: "Wordmark & Typography",
        body: [
          "The TOTUMO wordmark uses refined capital letters, classical proportions and generous spacing. It communicates authority, silence and permanence without excess.",
        ],
        primary: { title: "Primary · Editorial Serif", desc: "A high contrast editorial serif gives the brand elegance, heritage and sophistication. References: Canela, Ivar Display, Noe Display. Web: Cormorant Garamond." },
        secondary: { title: "Secondary · Neutral Sans", desc: "A precise neutral sans serif for navigation, specifications, captions, forms and data. References: Suisse Int’l, Söhne. Web: Inter." },
      },
      {
        id: "color", label: "05 · Color System",
        heading: "Color System",
        body: ["The palette must feel mineral and cinematic, not decorative. Gold appears as a restrained accent, never as an obvious luxury effect."],
      },
      {
        id: "values", label: "06 · Brand Values",
        heading: "Brand Values",
        values: [
          { k: "Origin", v: "We protect the value of where gold begins." },
          { k: "Craft", v: "We treat process, handling and presentation with precision." },
          { k: "Value", v: "We work with rare matter and enduring commercial worth." },
          { k: "Integrity", v: "We operate with accountability, documentation and responsibility." },
          { k: "Permanence", v: "We build standards designed to last." },
          { k: "Refinement", v: "We elevate raw matter through clarity, restraint and excellence." },
        ],
      },
      {
        id: "visual", label: "07 · Visual Language",
        heading: "Visual Language",
        body: [
          "The visual world of TOTUMO focuses on matter before ornament. Imagery shows gold as part of origin: veins, minerals, quartz, stone, dust, hands, light, documents and refined details, cinematic, close, tactile and carefully composed.",
        ],
        rules: [
          "Use macro and close-up compositions with large areas of light, stone or negative space.",
          "Show mineral textures, gold veins, quartz, powder, clean hands, documentation and refined tools.",
          "Avoid obvious lingots, cheap black-and-gold luxury, folklore or decorative mining clichés.",
          "Use gold as a material accent inside the image, not as the entire visual story.",
        ],
      },
      {
        id: "phrases", label: "08 · Phrases",
        heading: "Brand Phrases",
        phrases: ["Origin. Craft. Value.", "From earth to excellence.", "A vessel for origin value.", "The house of rare gold.", "Refined at origin.", "Precious. Rare. Enduring."],
      },
    ],
  },
  es: {
    eyebrow: "Sistema de Marca",
    title: "Códigos de la Casa",
    subtitle: "Origen. Oficio. Valor.",
    intro: "Los estándares, símbolos y principios que definen a TOTUMO como una casa de oro.",
    sections: [
      {
        id: "meaning", label: "01 · El Significado",
        heading: "El Significado de Totumo",
        body: [
          "Totumo comienza con la idea de un recipiente. En su forma original, el totumo es un contenedor natural: un objeto hecho para sostener, proteger y llevar lo valioso. Para la marca, este significado se eleva a una filosofía de casa contemporánea.",
          "Totumo es un recipiente de valor de origen: una casa creada para sostener, proteger y elevar el oro desde la tierra hacia el mundo.",
          "Para TOTUMO, el oro no se trata como ornamento. Se trata como materia, origen, estándar y responsabilidad.",
        ],
      },
      {
        id: "house", label: "02 · Casa de Oro",
        heading: "Casa de Oro",
        body: [
          "“Casa de Oro” define a TOTUMO como una casa con sus propios estándares, símbolos y principios. La posiciona más allá de una operación tradicional de minería o comercio y le otorga el carácter de una maison: estructurada, refinada, confiable y construida para perdurar.",
          "La palabra “Casa” habla de continuidad, custodia, excelencia y un sistema de estándares. La palabra “Oro” habla de rareza, materia, origen y valor.",
        ],
        quote: "Una casa para la materia rara. Un recipiente de valor de origen.",
      },
      {
        id: "symbol", label: "03 · El Símbolo",
        heading: "El Símbolo",
        body: [
          "El símbolo de TOTUMO es un monograma sello construido a partir del ritmo y la repetición de las propias letras de la marca. Construido desde la geometría de la T y la O, el signo crea un emblema equilibrado, simétrico y contenido.",
          "El marco oval representa continuidad, protección y origen. La estructura tipográfica interna refleja orden, precisión y refinamiento. El símbolo no ilustra el oro directamente, actúa como marca de casa: un sello de procedencia, valor y permanencia.",
        ],
        construction: "El signo se construye sobre un eje vertical de simetría. Un marco oval contiene la composición, mientras que las letras T y O, reflejadas y repetidas, generan el ritmo interno, medido contra una retícula geométrica constante.",
        principles: [
          { k: "Marco oval", v: "Continuidad, protección y origen." },
          { k: "Tipografía interna", v: "Orden, precisión y refinamiento." },
          { k: "Simetría", v: "Equilibrio, repetición y contención." },
        ],
        usesTitle: "El símbolo en uso",
        uses: [
          { label: "Sello de certificado", note: "En relieve sobre documentos de procedencia." },
          { label: "Cuño en metal", note: "Acuñado en oro como marca de origen." },
          { label: "Signo de casa", note: "Invertido para arquitectura y señalización." },
        ],
      },
      {
        id: "type", label: "04 · Tipografía",
        heading: "Logotipo y Tipografía",
        body: [
          "El logotipo de TOTUMO usa mayúsculas refinadas, proporciones clásicas y un espaciado generoso. Comunica autoridad, silencio y permanencia sin excesos.",
        ],
        primary: { title: "Primaria · Serif Editorial", desc: "Una serif editorial de alto contraste otorga elegancia, herencia y sofisticación. Referencias: Canela, Ivar Display, Noe Display. Web: Cormorant Garamond." },
        secondary: { title: "Secundaria · Sans Neutra", desc: "Una sans serif neutra y precisa para navegación, especificaciones, leyendas, formularios y datos. Referencias: Suisse Int’l, Söhne. Web: Inter." },
      },
      {
        id: "color", label: "05 · Sistema de Color",
        heading: "Sistema de Color",
        body: ["La paleta debe sentirse mineral y cinematográfica, no decorativa. El oro aparece como un acento contenido, nunca como un efecto de lujo evidente."],
      },
      {
        id: "values", label: "06 · Valores de Marca",
        heading: "Valores de Marca",
        values: [
          { k: "Origen", v: "Protegemos el valor de donde comienza el oro." },
          { k: "Oficio", v: "Tratamos el proceso, la manipulación y la presentación con precisión." },
          { k: "Valor", v: "Trabajamos con materia rara y valor comercial perdurable." },
          { k: "Integridad", v: "Operamos con responsabilidad, documentación y rendición de cuentas." },
          { k: "Permanencia", v: "Construimos estándares diseñados para perdurar." },
          { k: "Refinamiento", v: "Elevamos la materia bruta mediante claridad, contención y excelencia." },
        ],
      },
      {
        id: "visual", label: "07 · Lenguaje Visual",
        heading: "Lenguaje Visual",
        body: [
          "El mundo visual de TOTUMO se enfoca en la materia antes que el ornamento. La imagen muestra el oro como parte del origen: vetas, minerales, cuarzo, piedra, polvo, manos, luz, documentos y detalles refinados, cinematográfico, cercano, táctil y cuidadosamente compuesto.",
        ],
        rules: [
          "Usar composiciones macro y de primer plano con grandes áreas de luz, piedra o espacio negativo.",
          "Mostrar texturas minerales, vetas de oro, cuarzo, polvo, manos limpias, documentación y herramientas refinadas.",
          "Evitar lingotes evidentes, lujo barato en negro y oro, folclore o clichés decorativos de minería.",
          "Usar el oro como acento material dentro de la imagen, no como toda la historia visual.",
        ],
      },
      {
        id: "phrases", label: "08 · Frases",
        heading: "Frases de Marca",
        phrases: ["Origen. Oficio. Valor.", "De la tierra a la excelencia.", "Un recipiente de valor de origen.", "La casa del oro raro.", "Refinado en origen.", "Precioso. Raro. Perdurable."],
      },
    ],
  },
};

export function getByPath(obj, path) {
  return path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);
}
